/**
 * @file AppShell.tsx
 *
 * The persistent app chrome for the authenticated admin: a fixed, viewport-filling
 * shell with the {@link AdminHeader} (brand + account menu) on top and the active
 * screen below it. It wraps {@link ShopGate} (in index.tsx), so the top bar - and
 * therefore the account menu's Log out - is present across every authenticated
 * state: while the shop is loading, on the plan-ineligible / error gate screens,
 * and in the admin itself. Pre-auth states (the bootstrap loader, the login
 * screen) render without it.
 */

import type { ReactNode } from 'react';
import { AdminHeader } from './AdminHeader';
import styles from './AppShell.module.css';

/**
 * Renders the fixed shell with the top bar above the given content.
 *
 * @param props.children - The authenticated screen rendered below the header.
 *
 * @returns The app shell element.
 */
export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className={`gv-activated ${styles.shell}`}>
      <AdminHeader />
      {children}
    </div>
  );
}
